import { createUseStyles } from 'react-jss'
import {
  BLUE,
  BOX_SHADOW_10,
  BOX_SHADOW_50,
  BRIGHT_GRAY,
  DARK,
  DARK_GRAY,
  DARK_GRAY_05,
  DARK_GRAY_11,
  DARK_GRAY_20,
  DARK_GRAY_40,
  DARK_GRAY_53,
  DARK_GRAY_60,
  DARK_GRAY_80,
  DARK_GREEN,
  DARK_SECONDARY,
  GRAY,
  GRAY_22,
  GRAY_50,
  GRAY_65,
  GRAY_80,
  GREEN,
  GUN_GRAY,
  LIGHT_GRAY,
  NOT_AS_BRIGHT_GRAY,
  WHITE,
  WHITE_50
} from '@omnilert/components'

const useStyles = createUseStyles({
  '@global': {
    ':root': {
      '--safewalk-selection-container__background__color': 'rgba(254, 254, 254, 0.47)',
      '--action-button__color': WHITE,
      '--action-button__success__color': GREEN,
      '--action-button__box__shadow': BOX_SHADOW_10,
      '--card-button-carousel__color': GRAY_50,
      '--card-divider__color': LIGHT_GRAY,
      '--card_icon_color': BLUE,
      '--card__icon__loader_color': GRAY,
      '--card--text__color': DARK_GRAY_60,
      '--contact-input--border': DARK_GRAY_20,
      '--contact-input--background': NOT_AS_BRIGHT_GRAY,
      '--chat-bubble__box-shadow__color': GRAY,
      '--chat-bubble__text__color': DARK_GRAY_60,
      '--chat__content__text__color': DARK_GRAY,
      '--chat__message__date__separator__color': DARK_GRAY_40,
      '--emergency-sheet__first__child__text__color': DARK_GRAY_80,
      '--emergency-sheet__icon__stroke__color': DARK_GRAY_40,
      '--emergency-sheet__second__child__text__color': DARK_GRAY_60,
      '--file-upload--border': WHITE,
      '--form-input--text': DARK_GRAY_60,
      '--form__switch__checked__background__color': GRAY,
      '--form__switch__dial__background__color': DARK_GRAY_20,
      '--form__switch__unchecked__background__color': DARK_GRAY_20,
      '--header__background__color': WHITE,
      '--header__border__color': GRAY_50,
      '--header__emergency-button__background__color': WHITE_50,
      '--header__title__color': DARK_GRAY,
      '--image-upload__font': WHITE,
      '--image-upload__background': BRIGHT_GRAY,
      '--input__background': GRAY_22,
      '--input__border': DARK_GRAY_20,
      '--message__indicator__arrow__color': DARK_GRAY_40,
      '--message__indicator__text__color': DARK_GRAY_40,
      '--message__indicator__top-border__color': DARK_GRAY_05,
      '--no-results__text': DARK_GRAY_40,
      '--primary__page__background': WHITE,
      '--registration__link__text__color': DARK_GRAY,
      '--registration__message__text__color': DARK_GRAY_60,
      '--resource__description__text': DARK_GRAY_60,
      '--resource__icon__stroke': DARK_GRAY_40,
      '--resource__item__text': DARK_GRAY_80,
      '--scroll-indicator__background__color': GRAY_65,
      '--search-icon__stroke': DARK_GRAY_40,
      '--secondary__page__background__color': WHITE_50,
      '--section__background__color': BRIGHT_GRAY,
      '--shield__component__stroke__color': DARK_GRAY,
      '--splash-screen__background__color': GRAY_65,
      '--tab__border__color': GRAY,
      '--tab__nav__text__color': DARK_GRAY,
      '--tab__stroke__color': DARK_GRAY,
      '--text__primary': DARK_GRAY_80,
      '--tips__icon__stroke__color': DARK_GRAY_40,
      '--tips__text': DARK_GRAY_60
    },
    '@media screen and (prefers-color-scheme: dark)': {
      ':root': {
        '--safewalk-selection-container__background__color': GRAY_80,
        '--action-button__color': DARK,
        '--action-button__success__color': DARK_GREEN,
        '--action-button__box__shadow': BOX_SHADOW_50,
        '--card-button-carousel__color': DARK_GRAY_20,
        '--card-divider__color': GUN_GRAY,
        '--card_icon_color': BLUE,
        '--card__icon__loader_color': LIGHT_GRAY,
        '--card--text__color': LIGHT_GRAY,
        '--chat-bubble__box-shadow__color': DARK_GRAY_53,
        '--chat-bubble__text__color': GRAY,
        '--chat__content__text__color': GRAY,
        '--chat__message__date__separator__color': LIGHT_GRAY,
        '--contact-input--border': DARK_GRAY_20,
        '--contact-input--background': DARK,
        '--emergency-sheet__first__child__text__color': WHITE,
        '--emergency-sheet__icon__stroke__color': LIGHT_GRAY,
        '--emergency-sheet__second__child__text__color': LIGHT_GRAY,
        '--file-upload--border': DARK_SECONDARY,
        '--form-input--text': WHITE,
        '--form__switch__checked__background__color': DARK,
        '--form__switch__dial__background__color': LIGHT_GRAY,
        '--form__switch__unchecked__background__color': DARK,
        '--header__background__color': DARK,
        '--header__border__color': DARK_GRAY_11,
        '--header__emergency-button__background__color': DARK_SECONDARY,
        '--header__title__color': WHITE,
        '--image-upload__font': GRAY,
        '--input__background': DARK,
        '--input__border': LIGHT_GRAY,
        '--message__indicator__arrow__color': LIGHT_GRAY,
        '--message__indicator__text__color': LIGHT_GRAY,
        '--message__indicator__top-border__color': GRAY_22,
        '--no-results__text': LIGHT_GRAY,
        '--primary__page__background': DARK,
        '--registration__link__text__color': GRAY,
        '--registration__message__text__color': LIGHT_GRAY,
        '--resource__description__text': LIGHT_GRAY,
        '--resource__icon__stroke': LIGHT_GRAY,
        '--resource__item__text': WHITE,
        '--scroll-indicator__background__color': DARK,
        '--search__icon__stroke': LIGHT_GRAY,
        '--secondary__page__background__color': DARK_SECONDARY,
        '--section__background__color': DARK,
        '--shield__component__stroke__color': GRAY,
        '--splash-screen__background__color': DARK_GRAY_80,
        '--tab__border__color': DARK_GRAY_11,
        '--tab__nav__text__color': GRAY,
        '--tab__stroke__color': GRAY,
        '--text__primary ': WHITE,
        '--tips__icon__stroke': LIGHT_GRAY,
        '--tips__text': LIGHT_GRAY
      }
    }
  }
})

export default useStyles
